import bem from '../../utils/bem';

export const [modalBlock, modalBlockElement] = bem('rotations-modal');
export const [rotationsBlock, rotationsElement] = bem('rotations');
export const [rotationsColumnsBlock, rotationsColumnsElement] = bem('ad-rotation-columns');
